import {
  chapterConfig,
  isChapter,
  type ChapterConfig,
} from "@repo/vihangam-yog-shared";

/**
 * The chapter this build serves. One admin codebase is deployed once
 * per chapter; CI sets VITE_CHAPTER at build time (see ci.yml) and Vite
 * inlines it. Australia is the default so every existing build is
 * unchanged.
 */
const raw = import.meta.env.VITE_CHAPTER ?? "aus";

export const CHAPTER: ChapterConfig = chapterConfig(
  isChapter(raw) ? raw : "aus",
);
